import React from 'react';
import { Tag } from 'components/tag';
import { CurrencyAmount } from 'components/text';
import { TagType } from 'constants/ui';
const BalanceAmountPendingChip = ({ amount }) => (React.createElement("div", { className: "balance-block--chip-wrapper" },
    React.createElement(Tag, { className: "balance-block--chip", hasIcon: false, isClosable: false, readOnly: true, type: TagType.WARNING },
        React.createElement("span", { className: "balance-block--chip--text" },
            React.createElement("span", { className: "balance-block--chip--text--label" }, "Pending balance:"),
            React.createElement(CurrencyAmount, null, amount)))));
export default BalanceAmountPendingChip;
